var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91378 0.724121C4.39309 0.724121 0.724121 4.39309 0.724121 8.91378C0.724121 13.4345 4.39309 17.1034 8.91378 17.1034C13.4345 17.1034 17.1034 13.4345 17.1034 8.91378C17.1034 4.39309 13.4345 0.724121 8.91378 0.724121ZM8.91378 3.99998C10.4944 3.99998 11.7802 5.28576 11.7802 6.86636C11.7802 8.44697 10.4944 9.73274 8.91378 9.73274C7.33317 9.73274 6.0474 8.44697 6.0474 6.86636C6.0474 5.28576 7.33317 3.99998 8.91378 3.99998ZM8.91378 15.4655C7.25128 15.4655 5.28576 14.794 3.88533 13.1069C5.26938 12.0258 7.01378 11.3707 8.91378 11.3707C10.8138 11.3707 12.5582 12.0258 13.9422 13.1069C12.5418 14.794 10.5763 15.4655 8.91378 15.4655Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile1.f93dd9201edc5cf8956a45178ae37beb.svg";
export { ForwardRef as ReactComponent };